import { useLocation } from "react-router-dom";
import { detectLang } from "../i18n";
import { LegalPage, Section } from "./Legal";

export function Privacy() {
  const lang = detectLang(useLocation().pathname);

  if (lang === "ja") {
    return (
      <LegalPage title="プライバシーポリシー" lastUpdated="2026年9月26日">
        <Section title="1. 取得する情報">
          本サービスは以下の情報を取得します：WorkOSのユーザーID、ログイン時に表示するGoogleアカウントの名前・メールアドレス（当社のデータベースには保存しません）、再生履歴（再生したパッセージ・モード・速度・日時）、有料プランの契約情報（Stripeの顧客ID・契約ID・契約状態・請求期間の末日）。再生の設定（モード・速度など）はお使いの端末のブラウザにのみ保存します。
        </Section>
        <Section title="2. 利用目的">
          取得した情報は、本人の識別、ライブラリの「続きから」と再生済み表示、有料プランの契約状態の確認と再生権の判定、お問い合わせへの対応のために利用します。
        </Section>
        <Section title="3. 決済情報">
          有料プランの決済はStripe, Inc.が処理します。申込み時に、Stripeの顧客情報を作成するため、メールアドレスとWorkOSのユーザーIDをStripeに送信します。クレジットカード情報はStripeが取り扱い、当社は保持しません。
        </Section>
        <Section title="4. 委託先・第三者提供">
          当社は以下の事業者に業務を委託し、その範囲で情報を取り扱わせます：WorkOS（認証）、Stripe（決済）、Cloudflare（データの保管と配信）。法令に基づく場合を除き、第三者への提供は行いません。
        </Section>
        <Section title="5. データの保管">
          再生履歴と契約情報は、アカウントに紐づけてCloudflare（D1）上に保管します。アカウントの削除を希望される場合は、下記までご連絡ください。
        </Section>
        <Section title="6. セキュリティ">
          通信はすべてHTTPSで暗号化されます。APIキーはサーバー側で管理し、ブラウザには送信しません。セッションは暗号化Cookieで保護します。
        </Section>
        <Section title="7. お問い合わせ">
          プライバシーに関するお問い合わせは hy@prscnd.com までご連絡ください。
        </Section>
      </LegalPage>
    );
  }

  return (
    <LegalPage title="Privacy Policy" lastUpdated="September 26, 2026">
      <Section title="1. Information We Collect">
        We collect: your WorkOS user ID; your Google account name and email, shown while you are signed in (not stored in our database); your play history (passage, mode, speed, and time); and, if you subscribe, your Stripe customer ID, subscription ID, subscription status, and billing period end. Playback preferences (mode, speed, and so on) are stored only in your browser.
      </Section>
      <Section title="2. How We Use Information">
        We use this information to identify you, to show "continue" and played status in your library, to check your subscription and decide which collections you can play, and to answer your inquiries.
      </Section>
      <Section title="3. Payment Information">
        Stripe, Inc. processes payments for the paid plan. When you subscribe, we send your email address and WorkOS user ID to Stripe to create your customer record. Stripe handles your card details; we never store them.
      </Section>
      <Section title="4. Service Providers and Third Parties">
        We entrust processing to these providers: WorkOS (authentication), Stripe (payments), and Cloudflare (storage and delivery). We do not share your data with other third parties except as required by law.
      </Section>
      <Section title="5. Data Retention">
        Play history and subscription records are stored on Cloudflare (D1), scoped to your account. To delete your account, contact us at the address below.
      </Section>
      <Section title="6. Security">
        All communication is encrypted via HTTPS. API keys are managed server-side and never sent to the browser. Sessions are protected with an encrypted cookie.
      </Section>
      <Section title="7. Contact">
        For privacy inquiries, contact hy@prscnd.com.
      </Section>
    </LegalPage>
  );
}
